import UserProfileContent from "./user-profile-content";

export default UserProfileContent;